//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'dayjs'
import uniRate from "@/components/uni-rate/uni-rate.vue"
export default {
  name: 'commentItem',
  props: {
    // bodyId: {
    //   type: String,
    //   default: ''
    // }
    showCommentList: {
      type: Boolean,
      default: true
    },
    showBodyRate: {
      type: Boolean,
      default: false
    },
    detailId: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      starLevel: 5,
      count: '-',
      form: [],
      dataObj: 0,
      bodyId: '',
      noHead: '/static/comment/noHead.png',
      productId: ''
    }
  },
  components: { uniRate },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      if (this.type === 'specialty' || this.type === 'route') {
        this.productId = this.detailId
      } else {
        this.bodyId = this.detailId
      }
      this.$ajax({
        method: 'post',
        url: '/weChat/comment/list',
        data: {
          currentPage: '',
          pageSize: '',
          productId: this.productId,
          bodyId: this.bodyId,
          commentatorId: this.$store.state.userInfo.memberId || ''
        }
      }).then(result => {
        result.data.forEach(element => {
          element.createTime = moment(element.createTime).format('YYYY-MM-DD')
          if (element.isCryptonym === 1) {
            element.memberName = '匿名用户'
            element.headImage = this.noHead
          }
          if (element.headImage === '') {
            element.headImage = this.noHead
          }
        })
        this.dataObj = parseFloat(result.dataObj || 0)
        this.form = result.data
        this.count = result.count
        if (this.form.length > 2) {
          this.form = this.form.splice(0, 2)
        }
        this.$emit('updateComments', {count:this.count, dataObj:this.dataObj})
      }).catch(res => {

      })
    },
    toDetail() {
      uni.navigateTo({
        url: `/pages/comment/list?bodyId=${this.bodyId}&productId=${this.productId}`
      })
    }
  }
}
